<div class="page-header"><h1 class="page-title">Partner View</h1></div>

<nz-tabset [nzTabPosition]="'top'" nzType="card" nzSize="small" *ngIf="partner" [nzSelectedIndex]="selectedTabIndex" (nzSelectedIndexChange)="selectedTabIndex = $event">
	<nz-tab [nzTitle]="'Partner'" class="m-0">
		<div class="row">
			<div class="col">
				<div class="card">
					<div class="card-header">
						<span class="h3">Partner Information</span>
						<a [routerLink]="['/partner','edit',partner.id]" class="btn btn-primary float-end">Edit</a>
					</div>
					<div class="card-body">
						<table>
							<tbody>
								<tr><td class="w-75">ID: </td> <td>{{partner.id}} </td></tr>
								<tr><td>Name: </td> <td>{{partner.name}} </td></tr>
								<tr><td>Date of Creation: </td> <td>{{partner.createdAt|date}} </td></tr>
								<tr><td>Who Created: </td> <td>{{partner.createdBy?.username}} </td></tr>
								<tr><td>Partner Type: </td> <td>{{partner.partnerType}} </td></tr>
								<tr><td>Registration Number: </td> <td>{{partner.registrationNumber}} </td></tr>
								<tr><td>Address: </td> <td>{{partner.address}} </td></tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="card">
					<div class="card-header">
						<h3>Contact Information</h3>
					</div>
					<div class="card-body ps-2">
						<div><span class="h4">Email: </span> </div>
						<div><span class="h4">Notification Email: </span> </div>
						<div><span class="h4">Contact Persons: </span> </div>
						<table class="table table-sm">
							<thead class="table-info">
								<tr>
									<th>Name</th>
									<th>Email</th>
									<th>Phone</th>
									<th>Job Role</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let contact of partner.contacts">
									<td>{{contact.fullName}}</td>
									<td>{{contact.emailAddress}}</td>
									<td>{{contact.msisdn}}</td>
									<td>{{contact.jobRole}}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="col" *ngIf="partner.image">
				<img [src]="getLogoUrl" class="w-100"/>
			</div>
		</div>
	</nz-tab>
	<nz-tab [nzTitle]="'Change history'" class="m-0" *hasPermission="['AuditModificationList']">
		<app-audit-timeline *ngIf="selectedTabIndex == 1" [audits]="(modifications! | async)!" [downloadHeading]="'Partner Audit'" [downloadName]="'partner_audit'"></app-audit-timeline>
	</nz-tab>
</nz-tabset>
